module.exports = __webpack_public_path__ + "static/media/personas.c17cc4ed.svg";